// @flow

import type { Documents, Entities } from 'models/transactions';

type GroupedEntities = {
  create: Entities,
  update: Entities
}

export function flattenEntities(documents: Documents): Entities {
  return documents
    .reduce((acc, doc) => (
      [...acc, ...(doc.response || { entities: [] }).entities]
    ), []);
}

export function groupEntitiesByRole(entities: Entities): GroupedEntities {
  return entities
    .reduce((acc, e) => (
      {
        ...acc,
        [e.action]:
          acc.hasOwnProperty(e.action) ? acc[e.action] + 1 : 1,
      }
    ), {});
}

export function groupEntitiesByType(entities: Entities): Object {
  return entities
    .reduce((acc, e) => (
      {
        ...acc,
        [e.type]: {
          ...acc[e.type],
          [e.action]: (acc[e.type] || {})[e.action] ? acc[e.type][e.action] + 1 : 1,
          'ids': [...(acc[e.type] || {ids: []}).ids, e.id],
          related_cases: (acc[e.type] || {}).related_cases ?
            [...acc[e.type].related_cases, ...e.related_cases] : e.related_cases
        }
      }
    ), {});
}

export function uniqueCases(entities: Entities): number {
  return (
    new Set(entities.reduce((acc, e) => (
      [...acc, ...e.related_cases.map(c => c.id)]
    ), []))
  ).size;
}
